import { render, staticRenderFns } from "./CategoryAttributeDialog.vue?vue&type=template&id=19389c86&scoped=true"
import script from "./CategoryAttributeDialog.vue?vue&type=script&lang=js"
export * from "./CategoryAttributeDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryAttributeDialog.vue?vue&type=style&index=0&id=19389c86&prod&scoped=true&lang=css"
import style1 from "./CategoryAttributeDialog.vue?vue&type=style&index=1&id=19389c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19389c86",
  null
  
)

export default component.exports